export default "__VITE_ASSET__B23qNnwH__"